import { useEffect, useMemo, useState } from 'react';
import { sortArrList } from '../../../components/commonFunc';
import { TabEventFirstElement } from '../../../components/Contents/blogspage/TabEventFirstElement';
import { getAllActivities } from '../../../providers/apis/blogApi';
import { isHubEventType } from '../helper/hubItemHref';
import { HubFeatureCard } from '../layout/HubFeatureCard';
import { HubListingCardLink } from '../layout/HubListingCardLink';
import { HubListingView } from '../layout/HubListingView';
import { usePaginatedItems } from '../layout/usePaginatedItems';

function parseActivities(activities) {
  const blogs = activities.blogs.map((bItem) => ({
    postId: bItem.id,
    postType: bItem.Content_Type,
    title: bItem.Title,
    postDate: bItem.DateWritten,
    postMedia: bItem.Graphic1,
    postName: bItem.Relevance,
    creator: bItem.Author,
    content: bItem.Description,
  }));

  const podcasts = activities.podcasts.map((pItem) => ({
    postId: pItem.Id,
    postType: pItem.ContentType,
    title: pItem.Title,
    postDate: pItem.DatePublished,
    postMedia: pItem.Graphic1,
    postName: pItem.Relevance,
    creator: pItem.Author,
    content: pItem.Description,
  }));

  const events = activities.events.map((eItem) => ({
    postId: eItem.id,
    title: eItem.Title,
    postMedia: eItem.Graphic1,
    postType: eItem.ContentType,
    postDate: eItem.LastUpdated,
    postName: eItem.Relevance,
    eventStartDate: eItem.StartDate,
    eventEndDate: eItem.EndDate,
    eventUrl: eItem.EventPath,
    addressData: {
      address: eItem.Address,
      country: eItem.Country,
      city: eItem.City,
      state: eItem.State,
      zip: eItem.Zip,
      phone: eItem.Phone,
    },
  }));

  const news = activities.news.map((nItem) => ({
    postId: nItem.Id,
    title: nItem.Title,
    postMedia: nItem.Graphic1,
    postDate: nItem.DatePublished,
    postType: nItem.ContentType,
    postName: nItem.Relevance,
    link: nItem.Source,
  }));

  return sortArrList(blogs.concat(podcasts).concat(events).concat(news));
}

export function ArticleCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const firstItem = items[0];
  const listItems = useMemo(() => items.slice(1), [items]);
  const { pageItems, totalPages, currentPage, onPageChange } = usePaginatedItems(listItems);

  useEffect(() => {
    const loadFeatured = async () => {
      setLoading(true);
      try {
        const activitiesRes = await getAllActivities();
        setItems(parseActivities(activitiesRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadFeatured();
  }, []);

  const renderFeatured = (item) => {
    if (isHubEventType(item.postType)) {
      return (
        <HubListingCardLink item={item} className="block no-underline text-inherit cursor-pointer">
          <TabEventFirstElement firstBlog={item} />
        </HubListingCardLink>
      );
    }

    return <HubFeatureCard firstBlog={item} />;
  };

  return (
    <HubListingView
      title="Featured"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
    />
  );
}
